import React from "react";
import { useParams } from "react-router-dom"
import { getApi } from '../../api/endpoints.js';
import ListingComponent from '../../components/ListingComponent.js';

const Listing = () => {
  const defaultHeaderConfig = { disableSort: false };
  const params = useParams();
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Billing Month',
      attr: 'billing_month',
      disableSort: true
    },
    {
      label: 'Amount',
      attr: 'amount',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
    },
    {
      label: 'Remarks',
      attr: 'remarks',
      disableSort: true
    },
  ]

  return <>
    <ListingComponent
      key={'PAGES.PartnerAssetBillsListingPage.name'}
      listingMutation={getApi('partnerAssetBills')}
      className="partner-asset-bills-listing-page"
      contentHeading="Partners Asset Bills - Results"
      headers={headers}
      recordsKey="partner_asset_bills"
      params={{ partner_id: params.id }}
    />
  </>
};

export default Listing;
